export default __webpack_public_path__ + "static/media/theme.ba4dbebb.png";